import { flexRender, Header } from "@tanstack/react-table";
import clsx from "clsx";

import { TableMetaProps } from "@/hooks/table/useTableConfig";

const DraggedColumnHeader = <T,>({ header }: { header: Header<T, unknown> | undefined }) => {
  if (!header) return null;
  const meta: TableMetaProps = header.column.columnDef.meta || {};
  const Icon = meta.heading?.icon || null;

  return (
    <div
      className={clsx(
        "relative flex cursor-grabbing select-none items-center gap-1.5 truncate border-x border-b border-x-secondary border-b-primary bg-secondary px-4 py-2.5 text-start text-sm font-medium text-tertiary opacity-75",
        meta.heading?.className,
      )}
    >
      {Icon && <Icon className="size-4 shrink-0 stroke-2 text-quaternary" />}
      {flexRender(header.column.columnDef.header, header.getContext())}
    </div>
  );
};

export default DraggedColumnHeader;
